const getTitle = (item: any) => {
  return item.type === 'st:site' ? item.name : item.title;
};

const getName = (item: any) => {
  if (item.name === 'documentLibrary') {
    return item.description ? item.description : item.name;
  }

  return item.type === 'st:site' ? item.title : item.name;
};

export const remapAssocItems = (item: any) => ({
  description: item.description,
  displayPath: item.displayPath,
  isContainer: item.isContainer,
  name: getName(item),
  nodeRef: item.nodeRef,
  title: getTitle(item),
  type: item.type,
  selectable: item.selectable,
});

export const getFileType = (type: string) => {
  switch (type) {
    case 'st:sites':
    case 'st:site': {
      return 'generic-site';
    }

    case 'cm:folder':
    case 'ctfd:baseFolder': {
      return 'generic-folder';
    }

    default: {
      return 'generic-file';
    }
  }
};

export const getValue = (value: any) => {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    if (value[0]) {
      return value.map(item => item.nodeRef || item);
    }

    return value;
  }

  return value.split(',');
};

export const getOptionsLabel = (option: any, label: string) => {
  if (label.includes('|#alf#|')) {
    let result = '';
    let clean = true;
    const labels = label.split('|#alf#|');
    labels.forEach(row => {
      if (!clean || option[row] === '') {
        clean = false;
      } else {
        const toAdd = option[row] || row;
        result += toAdd;
      }
    });

    return result;
  }

  return option[label];
};
